import React from "react";
import * as S from "./Cards.styes";
import VendasConsorcio from "../../assets/images/vendasConsorcio.png";
import Solicitacao from "../../assets/images/solicitacaoAcesso.png";
import ConsultaProposta from "../../assets/images/consultarProposta.png";
import LogoPortalDoConsorcio from "../../assets/images/portal-do-consorcio.png";

function Cards({ increment }) {
  return (
    <S.Cards>
      <S.Card>
        <img onClick={increment} src={VendasConsorcio} alt="app vendas" />
        <p>Acesso ao Sistema de Vendas de Consórcio</p>
      </S.Card>
      <S.Card>
        <a
          href={process.env.REACT_APP_SOLICITACOESACESSO_URL}
          target="_blank"
          referrerPolicy="origin"
          rel="noreferrer"
        >
          <img src={Solicitacao} alt="app vendas" />
        </a>
        <p>Solicitação de acesso ao sistema de vendas de Consórcio</p>
      </S.Card>
      <S.Card>
        <a
          href={process.env.REACT_APP_CONSULTAPROPOSTA_URL}
          target="_blank"
          referrerPolicy="origin"
          rel="noreferrer"
        >
          <img src={ConsultaProposta} alt="app vendas" />
        </a>
        <p>Consultar Propostas</p>
      </S.Card>
      <S.Card>
        <a
          href={process.env.REACT_APP_PORTALDOCONSORCIO_URL}
          target="_blank"
          referrerPolicy="origin"
          rel="noreferrer"
        >
          <img src={LogoPortalDoConsorcio} alt="portal do consorcio" />
        </a>
        <p>Portal do Consórcio (Gestão de consórcio de seus clientes)</p>
      </S.Card>
    </S.Cards>
  );
}

export default Cards;
